'use client';
import {useParams, useRouter} from 'next/navigation';
import Image from 'next/image';
import Link from 'next/link';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiTypography from '@new-components/atoms/MuiTypography';
import {ImgProps} from '@custom-types/ImgProps';
import {Route} from '@constants/appRoutes';

export interface CommunityPropertyCardProps {
  key: string;
  url: string;
  bedRoom: string;
  bgImg: ImgProps;
  unitTypes: string;
  communityName: string;
  unitsAvailable: number;
}
const CommunityPropertyCard: React.FC<CommunityPropertyCardProps> = (props) => {
  const {lang} = useParams();
  const router = useRouter();
  return (
    <MuiBox
      component={Link}
      prefetch={false}
      href={Route.withLang(
        Route.withQueryStr(
          Route.UNITS(),
          `text=${props.communityName}&bdr=${props.url}`
        ),
        lang as string
      )}
      sx={{
        width: '100%',
        height: '356px',
        overflow: 'hidden',
        textDecoration: 'none',
      }}>
      <MuiBox
        sx={{
          borderRadius: '16px',
          backgroundColor: '#ffffff',
          boxShadow: '0px 2px 10px 0px #0000000A',
        }}>
        <MuiBox sx={{width: '100%', height: '220px', position: 'relative'}}>
          <MuiBox
            sx={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              zIndex: 0,
            }}>
            <Image
              fill
              src={props.bgImg.src}
              alt={props.bgImg.alt}
              style={{
                objectFit: 'cover',
                height: '100%',
                borderRadius: '16px 16px 0px 0px',
              }}
            />
          </MuiBox>
        </MuiBox>
        <MuiBox
          sx={{
            width: '100%',
            height: '136px',
            padding: '20px 24px 24px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}>
          <MuiBox sx={{display: 'flex', flexDirection: 'column', gap: '2px'}}>
            <MuiTypography
              sx={{color: '#2d2d2d', opacity: '50%', lineHeight: '125%'}}>
              {props.bedRoom}
            </MuiTypography>

            <MuiTypography
              variant='h3'
              sx={{
                color: '#000000',
                fontSize: '19px',
                fontWeight: 500,
                lineHeight: '125%',
                letterSpacing: '-0.4px',
              }}>
              {props.unitTypes}
            </MuiTypography>
          </MuiBox>
          <MuiBox>
            <MuiTypography
              sx={{color: '#2d2d2d', fontSize: '16px', fontWeight: 400}}>
              {props.unitsAvailable} {props.unitsAvailable > 1 ? 'Units': 'Unit'} Available
            </MuiTypography>
          </MuiBox>
        </MuiBox>
      </MuiBox>
    </MuiBox>
  );
};
export default CommunityPropertyCard;
